import React, { useEffect, useState } from 'react';

import AlarmModuleService, {
  IAlarmModuleService,
} from 'services/AlarmModuleService';
import Summary from './components/Summary/Summary';
import ListView from './components/ListView/ListView';
import ChartsView from './components/ChartsView/ChartsView';
import ActionTopBar from './components/ActionTopBar/ActionTopBar';

import { AlarmRulesCount, AlarmMetadata } from 'types/types';

const AlarmManagement: React.FC = () => {
  const [alarmsCount, setAlarmsCount] = useState<AlarmRulesCount>({
    ActiveAlarms: 0,
    AllAlarms: 0,
    PausedAlarms: 0,
  });

  const fetchAlarmsCount = async () => {
    const niService: IAlarmModuleService = new AlarmModuleService();
    try {
      niService.GetAlarmRulesCount().then((data) => {
        setAlarmsCount(data);
      });
    } catch (error) {
      console.error('Failed to fetch alarm rules count', error);
    }
  };

  useEffect(() => {
    fetchAlarmsCount();
  }, []);

  return (
    <div className="alarm-management">
      <div className="main-container">
        <div>
          <span className="main-container-title">Alarm Notification</span>
        </div>
        <div>
          <ActionTopBar alarmsCount={alarmsCount} />
        </div>
        <div>
          <Summary alarmsCount={alarmsCount} />
        </div>
        <div>
          <ListView
            alarmsCount={alarmsCount}
            fetchAlarmsCount={fetchAlarmsCount}
          />
        </div>
        <div>
          <ChartsView />
        </div>
      </div>
      {/* <div>
        <Button
          variant="outlined"
          onClick={() =>
            granularityDateRangePickerRef.current?.handleShowModal(true)
          }
        >
          Open dialog
        </Button>
        <GranularityDateRangePicker
          dateFrom={values.current.dateFrom}
          selectedGranularity={values.current.selectedGranularity}
          dateTo={values.current.dateTo}
          ref={granularityDateRangePickerRef}
          selectedFilterOption={values.current.selectedFilterOption}
          granularityOptions={granularityOptions}
          selectedValuesSpecific={values.current.selectedValuesSpecific}
          customFilteredEnteredValues={
            values.current.customFilteredEnteredValues
          }
          selectedValuesCustom={values.current.selectedValuesCustom}
          handleApplyFilter={(body: GlobalDateFilter) => {
            console.log(body);
          }}
          calendarFilterOptions={calendarFilterOptions}
        />
      </div> */}
    </div>
  );
};

export default AlarmManagement;
